/**
 * Replaces problematic characters from attribute that is used as a selector, for example class name or `id`
 *
 * Brackets `(` ,`)` are problematic in Jest unit tests.
 */
export function sanitizeSelectorValue(value: string) {
  return value.replace('(', '_').replace(')', '_');
}
